<template>
  <div class="step-info">
    <span class="title"> {{ title }} </span>
    <span class="content">
      <slot name="content"> </slot>
      <span @click="showToggle = !showToggle" class="toggle" v-if="toggle"> {{ toggle }} </span>
      <slot v-if="toggle && showToggle" name="toggle"> </slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    toggle: String,
  },
  data() {
    return {
      showToggle: false,
    }
  }
};
</script>


<style scoped lang="scss">
@use 'assets/scss/_helpers/display';
@use 'assets/scss/_helpers/typography';
@use 'assets/scss/_variables/typographies';

.step-info {
  padding: 24px;
  border-left: 1px solid blue;

  .title {
    @include typography.font(typographies.$headings, h5);
  }

  .content {
    @include typography.font(typographies.$fonts, body);
  }

  .toggle {
    display: block;
    font-weight: 700;
    color: blue;
  }
}
</style>